import getHost from 'utils/getHost';
import Environments from 'constants/Environments';

export default () => {
  return getHost() === Environments.PRODUCTION.host;
};
